
import axios from '@/axios.js'
import url from '@/url.js'

export default {
  getProvinsi({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const ord = {
        ord: "asc"
      }
      const conn = {
        method: 'get',
        url: `${url.base}/provinsi`,
        params: Object.assign(payload, ord),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        commit('SET_PROVINSI_TOTAL', res.data.recordsTotal )
        commit('SET_PROVINSI_LIST', res.data.data )
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  getKabKot({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const ord = {
        ord: "asc"
      }
      const conn = {
        method: 'get',
        url: `${url.base}/kabupaten-kota`,
        params: Object.assign(payload, ord),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        commit('SET_KABKOT_TOTAL', res.data.recordsTotal )
        commit('SET_KABKOT_LIST', res.data.data)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  getKecamatan({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const ord = {
        ord: "asc"
      }
      const conn = {
        method: 'get',
        url: `${url.base}/kecamatan`,
        params: Object.assign(payload, ord),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        commit('SET_KECAMATAN_TOTAL', res.data.recordsTotal )
        commit('SET_KECAMATAN_LIST', res.data.data)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudProvinsi({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/provinsi`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudKabKot({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/kabupaten-kota`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudKecamatan({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/kecamatan`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
}
